import React from "react";
import { Reveal } from "@/components/Reveal";

const chapters = [
  {
    n: "01",
    title: "Water is family infrastructure.",
    body: "Every glass, every shower, every appliance. The right system quietly makes life better in a thousand small ways — and we treat it that way.",
  },
  {
    n: "02",
    title: "Non-electric, on purpose.",
    body: "Kinetico's twin-tank design uses the movement of the water itself to regenerate. No timers, no plugs, no waste — soft water on demand, 24/7.",
  },
  {
    n: "03",
    title: "Local hands, national spine.",
    body: "We're neighbors here in Northern Utah and Southern Idaho. Kinetico backs every install with a warranty measured in decades.",
  },
  {
    n: "04",
    title: "Test before you spend.",
    body: "We start with a free in-home water test. You'll see exactly what's in your water before we ever recommend a system. No pressure. No pretending.",
  },
];

export default function Manifesto() {
  return (
    <section
      className="relative py-32 lg:py-48 px-6 lg:px-10 overflow-hidden"
      data-testid="manifesto-section"
    >
      <div className="ambient-glow-blue" style={{ top: "10%", right: "-30%", opacity: 0.4 }} />

      <div className="mx-auto max-w-[1400px] relative">
        <div className="grid grid-cols-12 gap-6 lg:gap-10 mb-24">
          <div className="col-span-12 lg:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.35em] text-[color:var(--blue)]">Chapters</div>
            <div className="mt-2 text-[11px] uppercase tracking-[0.35em] text-[color:var(--muted)]">The way we work</div>
          </div>
          <div className="col-span-12 lg:col-span-9">
            <Reveal>
              <h2 className="font-display font-semibold text-[clamp(2.5rem,7vw,6rem)] leading-[0.95] text-white">
                A manifesto for<br />
                <span className="font-editorial italic font-normal text-[color:var(--blue)]">
                  quiet, permanent
                </span>{" "}
                water.
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-y-16 lg:gap-y-24 lg:gap-x-10">
          {chapters.map((c, i) => (
            <Reveal
              key={c.n}
              delay={i * 0.05}
              className={`col-span-12 lg:col-span-6 ${i % 2 === 1 ? "lg:mt-24" : ""}`}
              testId={`manifesto-chapter-${c.n}`}
            >
              <div className="flex items-start gap-6 lg:gap-8">
                <div className="font-display text-[clamp(3rem,6vw,5rem)] font-black text-[color:var(--green)] leading-none tabular shrink-0">
                  {c.n}
                </div>
                <div>
                  <h3 className="font-display font-semibold text-[clamp(1.5rem,2.4vw,2.4rem)] text-white leading-[1.05]">
                    {c.title}
                  </h3>
                  <p className="mt-4 text-[15px] leading-[1.75] text-[color:var(--muted)] font-body max-w-lg">
                    {c.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
